//console.log('platform/viewer/src/routes/Local/fileLoader.js');

export default class FileLoader {
  fileType;
  loadFile(file, imageId) { }
  getDataset(image, imageId) { }
  getStudies(dataset, imageId) { }
}
